import { Card, CardBody } from "reactstrap";
import { Btn, H3, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../Service/DynamicImage";
import { ContactSidebarCallbackProp } from "../../Type/ContactType";
import NavComponent from "./NavComponent";
import { useAppDispatch, useAppSelector } from "../../Redux-Toolkit/Hooks";
import { ContactFilter } from "../../Constant";
import { setContactFilter } from "../../Redux-Toolkit/Reducers/ContactSlice";

const ContactSideBar = ({ callback }: ContactSidebarCallbackProp) => {
  const { contactFilter } = useAppSelector((state) => state.contact);
  const dispatch = useAppDispatch();

  return (
    <div className="md-sidebar">
      <Btn tag="a" color="primary" className="md-sidebar-toggle" onClick={() => dispatch(setContactFilter())}>{ContactFilter}</Btn>
      <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${contactFilter ? "open" : ""}`}>
        <div className="email-left-aside">
          <Card>
            <CardBody>
              <div className="email-app-sidebar left-bookmark">
                <div className="d-flex">
                  <div className="d-flex-size-email">
                    <Image className="me-3 rounded-circle" src={dynamicImage("user/user.png")} alt="" />
                  </div>
                  <div className="flex-grow-1">
                    <H3 className="f-w-600">MARK JENCO</H3>
                    <P>Markjecno@gmail.com</P>
                  </div>
                </div>
                <NavComponent callbackActive={callback} />
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ContactSideBar;
